

export default () => {
    $("button.btn-about-blog").off('click').click(function() {
        $(this).find("i").toggleClass("fa-chevron-down fa-chevron-up");
    });
}
